<template>
  <div class="weui-cell" :class="{'weui-cell_access': isLink || !!link}" @click="onClick">
    <div class="weui-cell__hd">
      <slot name="icon"></slot>
    </div>
    <div class="weui-cell__bd">
      <p style="padding:4px 0;">{{title}}</p>
    </div>
    <div class="weui-cell__ft" :class="{'no-arrow': status || progress}">
      {{value}}
      <slot name="value"></slot>
      <slot></slot>
      <span class="weui-icon-finished" v-if="progress >= 1 || status==='finished'"></span>
      <span class="weui-icon-error" v-if="status==='error'"></span>
      <div class="cell-status" v-if="progress > 0 && progress < 1">
        <y-circle :percent="progress*100" :trail-width="6" :stroke-width="6"></y-circle>
      </div>
    </div>
    <slot name="child"></slot>
  </div>
</template>

<script>
import YCircle from './circle'
export default {
  components: {YCircle},
  props: {
    title: String,
    value: [String, Number, Array],
    isLink: Boolean,
    status: String,
    progress: [Number, String],
    link: {
      type: [String, Object]
    }
  },
  methods: {
    onClick () {
      if (this.$router && this.link) {
        this.$router.push(this.link)
      }
    }
  }
}
</script>
